export const process = (encrypt, text, cypher) => {
	return {
		type: "PROCESS",
		payload: {
			encrypt,
			text,
			cypher,
		},
	};
};
